import { Environment as KameleoonEnv } from "@kameleoon/react-sdk";
import { ENVS } from "./envs";
export const kameleoonEnvMapping = {
    [ENVS.DEV]: KameleoonEnv.Development,
    [ENVS.PREVIEW]: KameleoonEnv.Staging,
    [ENVS.LIVE]: KameleoonEnv.Production,
};
